module.exports = {"title":"Download your tickets","content":"Click on the button to download your tickets.","download":"Download","msg":{"yay":"Yay!","oops":"Oops!","error":"Your token is invalid."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/ElectronicTicket/locales/fr.json
// module id = 1990
// module chunks = 0